import { mutations } from '@src/requests/mutations';
import { queries } from '@src/requests/queries';

export const requests = {
  mutations,
  queries,
};
